import { createFileRoute } from "@tanstack/react-router";
import { getDoctors } from "@/lib/server-functions";
import DoctorsList from "@/pages/DoctorsList";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { doctorsListJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/doctors/")({
  loader: async () => {
    const doctors = await getDoctors();
    return { doctors };
  },

  head: ({ loaderData }) => {
    const doctors = loaderData?.doctors;

    const departments = doctors
      ? [...new Set(doctors.map((d) => d.department).filter(Boolean))].join(", ")
      : "";

    const practitionerNames = doctors
      ? doctors.map((d) => d.practitioner_name).join(", ")
      : "";

    const pageUrl = getPageUrl("/doctors");

    return {
      meta: [
        {
          title: "Find a Doctor in Kathmandu — KNMC Specialists, Nepal",
        },
        {
          name: "description",
          content:
            "Meet top doctors and specialists in Kathmandu, Nepal at KNMC Hospital. Search by department and book appointments online.",
        },
        {
          name: "keywords",
          content: `best doctors in Kathmandu, specialists Nepal, find a doctor Kathmandu, KNMC doctors, consultants Nepal${departments ? `, ${departments}` : ""}${practitionerNames ? `, ${practitionerNames}` : ""}`,
        },
        {
          property: "og:title",
          content: "Find a Doctor in Kathmandu — KNMC",
        },
        {
          property: "og:description",
          content:
            "World-class doctors in Kathmandu, Nepal. Book online with KNMC Hospital.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        doctorsListJsonLd(doctors ?? []),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { doctors } = Route.useLoaderData();
    return <DoctorsList doctors={doctors} />;
  },
});